import * as React from "react";
import { forwardRef } from "react";
const SvgPolice = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 11.504c-.188 0 .092.01.031.016-.054-.001-.166 0-.031.002-17.71 0-32.894 9.938-32.686 16.283-.1 2.372 2.03 3.634 6.694 4.894.627.17 1.255.319 1.883.475v-3.475c8.083-2.602 15.931-3.52 24.086-3.623h.046c8.127.058 16.425 1.205 24.086 3.623v3.447c.628-.147 1.256-.289 1.883-.447 4.685-1.18 6.793-2.522 6.694-4.894C82.894 21.46 67.709 11.504 50 11.504m0 16.783c-6.518.077-14.704.758-21.984 3.05v3.815c7.28-2.293 15.466-2.208 21.984-2.285 6.518.077 14.704-.008 21.984 2.285v-3.814c-7.28-2.293-15.466-2.974-21.984-3.05m-20.93 8.854-1.062.324a26.3 26.3 0 0 0-1.545 7.95c.013 10.11 2.88 18.531 10.805 24.812-8.035 3.826-18.236 8.992-24.457 13.103A50 50 0 0 0 50 100a50 50 0 0 0 37.195-16.666c-6.22-4.111-16.426-9.28-24.463-13.107 7.925-6.28 10.792-14.702 10.805-24.813a26.3 26.3 0 0 0-1.545-7.95l-1.062-.321C68.544 40.485 63.098 45.07 50 45.07s-18.544-4.587-20.93-7.93" />
  </svg>
);
const ForwardRef = forwardRef(SvgPolice);
export default ForwardRef;
